export default "__VITE_ASSET__CyQMV6hb__"